import axios from 'axios';
import store from "../store";
import { logout } from "../actions/auth";
import { notification } from "../actions/alert";
import { getBaseUrl } from "../config";

const regulateService = (config, callback, showTriggers = true) => {
    console.log('🌐 [REQUEST] API Request:', {
        url: config.url,
        method: config.method,
        baseURL: config.baseURL,
        headers: config.headers
    });

    return axios(config)
        .then(res => {
            console.log('✅ [REQUEST] API Response:', {
                url: config.url,
                status: res.status,
                data: res.data
            });
            let { data, status } = res;
            if (callback && typeof callback === 'function') {
                data = callback(data);
            }
            return {
                success: true, data, status
            }
        })
        .catch(err => {
            console.error('❌ [REQUEST] API Error:', {
                url: config.url,
                error: err.message,
                response: err.response?.data,
                status: err.response?.status,
                headers: err.response?.headers
            });
            
            const { response = {} } = err,
                { status, data } = response;

            if (!status) {
                console.error('Network Error Details:', {
                    message: err.message,
                    code: err.code,
                    config: {
                        url: config.url,
                        baseURL: config.baseURL
                    }
                });
                notification('Network Error: ' + err.message, 'error')
            }
            if (status === 401) {
                store.dispatch(logout());
            }
            if (showTriggers && status === 500) {
                notification(response.data.message, 'error');
            }
            if (showTriggers && status === 400) {
                notification(response.data.message, 'error')
            }
            if (!Object.keys(response).length) {
                console.error('No response data:', err.message)
                return {
                    success: false,
                    data: { message: err.message },
                    status: 0,
                    message: err.message
                }
            }
            return {
                success: false, data, status, message: err.message
            }
        })
}

const getConfig = ({uri, baseUrl, method, data = {}, headers = {}}) => {
    const token = localStorage.getItem('token');
    console.log('🔧 [REQUEST] getConfig - Token present:', !!token);
    console.log('🔧 [REQUEST] getConfig - Token length:', token ? token.length : 0);
    
    const config = {
        url: uri,
        baseURL: baseUrl,
        headers: {
            'x-auth-token': token,
            'Content-Type': "application/json",
            ...headers
        },
        method,
        data
    };
    
    console.log('🔧 [REQUEST] getConfig - Final config:', {
        url: config.url,
        method: config.method,
        headers: config.headers,
        data: config.data
    });
    
    return config;
}

export function requestGet({ uri, callback, baseUrl = getBaseUrl(), showTriggers, headers }) {
    return regulateService(getConfig({uri, baseUrl, method: 'GET', headers}), callback, showTriggers)
}

export function requestPut({ uri, body, callback, showTriggers, baseUrl = getBaseUrl() }) {
    return regulateService(getConfig({uri, baseUrl, method: 'PUT', data: body}), callback, showTriggers)
}

export function requestDelete({ uri, body, callback, showTriggers, baseUrl = getBaseUrl() }) {
    return regulateService(getConfig({uri, baseUrl, method: 'DELETE', data: body}), callback, showTriggers)
}

export function requestPatch({ uri, body, callback, showTriggers, baseUrl = getBaseUrl() }) {
    return regulateService(getConfig({uri, baseUrl, method: 'PATCH', data: body}), callback, showTriggers)
}

export function requestPost({ uri, body, callback, showTriggers, baseUrl = getBaseUrl() }) {
    return regulateService(getConfig({uri, baseUrl, method: 'POST', data: body}), callback, showTriggers)
}